export var createTestIsSecureContextSupport = function createTestIsSecureContextSupport(window) {
  return function () {
    return window !== null && window.hasOwnProperty('isSecureContext');
  };
};